import React, { useEffect, useState } from "react";
import AdminDataTable from "../../components/common/AdminDataTable";
import TableHeading from "../../components/common/TableHeading";
import SearchAndAddItem from "../../components/common/TableData";
import { ROUTES } from "../../routes/url-constant";
import { useNavigate } from "react-router-dom";
import { allOnsiteEmployee, getAllCompanies } from "../../../services/api-services";
import { toastEmitter } from "../../../utills/utilities";
import { API_RESPONSE } from "../../../utills/app-constant";
import { useSelector } from "react-redux";
import AccessPermissionpage from "./AccessPermissionpage";
import moment from "moment";
import { RIGHTARROW_ICON } from "../../../utills/image-constant";

const OnSiteAssessment = () => {

  const [pending, setPending] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [sortColumn, setSortColumn] = useState("id");
  const [sortDirection, setSortDirection] = useState("desc");
  const [permissionAccess, setPermissionAccess] = useState();
  const [companyList, setCompanyList] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState(localStorage.getItem("OnsiteCompanyId") || "");
  const [totalElement, setTotalElement] = useState();
  const { value } = useSelector((state) => state?.adminRole);
  const navigate = useNavigate();
  const EmployeeData = useSelector((state) => state?.loggedUser?.value);
  // Read company filter from localStorage, if available
  let onSiteCompanyId = localStorage.getItem("OnsiteCompanyId");

  useEffect(() => {
    const RoleAccessFilterData =
      value && value.filter((v) => v.moduleName === "Assessor");
    setPermissionAccess(RoleAccessFilterData?.[0]);
  }, [value]);

  // Build the payload inline and fetch Onsite Employee data
  const getAllEmployeeData = async () => {
    setPending(true);
    const currentPayload = {
      pageIndex: page,
      pageSize: pageSize,
      searchText: searchText,
      direction: sortDirection,
      filterByFieldName: sortColumn,
      companyId: onSiteCompanyId ? onSiteCompanyId : selectedCompanyId || "",
      type: "Assessor",
      assessorId: EmployeeData?.roleName == "Assessor" ? EmployeeData?.id : ""
    };

    try {
      const response = await allOnsiteEmployee(currentPayload);
      if (response?.data?.responseCode === 404) {
        setRowData([]);
      } else if (response?.data?.responseCode === 200) {
        const res = response?.data?.data?.companyAssessorResponseList;
        setRowData(res);
        setTotalElement(response?.data?.responseBody?.totalElement);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    } finally {
      setPending(false);
    }
  };

  // Trigger the API call when any dependency changes
  useEffect(() => {
    getAllEmployeeData();
  }, [page, pageSize, searchText, sortColumn, sortDirection, selectedCompanyId, onSiteCompanyId]);

  // Fetch the list of companies for filtering
  const getAllCompany = async () => {
    setPending(true);
    try {
      const response = await getAllCompanies();
      if (response?.data?.responseCode === 404) {
        setCompanyList([]);
      } else if (response?.data?.responseCode === 200) {
        const companyOptions = response?.data?.responseBody.map((data) => ({
          value: data?.id,
          label: data?.companyName,
          Status: data?.status,
        }));
        setCompanyList(companyOptions);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    getAllCompany();
  }, []);

  const handleModelSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleSelect = (event) => {
    const selectedValue = event.target.value;
    setSelectedCompanyId(selectedValue);
    if (selectedValue === "") {
      localStorage.removeItem("OnsiteCompanyId");
    } else {
      localStorage.setItem("OnsiteCompanyId", selectedValue);
    }
  };

  const handleClearFilter = () => {
    setSelectedCompanyId("");
    localStorage.removeItem("OnsiteCompanyId");
  };

  const addButtonClick = () => {
    navigate(ROUTES.ADDONSITE);
  };


  const tableCustomStyles = {
    headRow: {
      style: {
        color: "#1B2128",
        fontSize: "14px",
      },
    },
    rows: {
      style: {
        color: "#1B2128",
        fontSize: "14px",
      },
    },
  };

  const tblColumns = [
    {
      code: "Action",
      name: "Action",
      width: "150px",
      sortable: false,
      cell: (row) => (
        <div className="d-flex">
          {row?.adminResponsePayload?.status === 1 && row?.assessorCampaignResponse?.isAssessment === 0 && (
            <button
              className="border-0 bg-primary rounded px-2 py-1 text-white"
              onClick={() =>
                navigate(ROUTES.ONSITESCORE, { state: { Data: row } })
              }
            >
              Start Test
            </button>
          )}
          {row?.adminResponsePayload?.status === 1 && row?.assessorCampaignResponse?.isAssessment === 1 && (
            <button
              className="border-0 bg-primary rounded px-2 py-1 text-white"
              onClick={() =>
                navigate(ROUTES.ONSITESCORE, { state: { Data: row } })
              }
            >
              Continue Test
            </button>
          )}
          {row?.adminResponsePayload?.status === 1 && row?.assessorCampaignResponse?.isAssessment === 2 && (
            <button
              type="button"
              className="btn btn-secondary px-2 py-1 textfont12"
              data-toggle="tooltip"
              data-placement="top"
              data-custom-class="custom1-tooltip"
              title="Cannot proceed further until admin validates the test"
            >
              Add Score
            </button>
          )}
        </div>
      ),
    },
    {
      code: "employeeName",
      name: "Employee Name",
      width: "180px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.adminResponsePayload?.name}</div>
      ),
    },
    {
      code: "companyName",
      name: "Company Name",
      width: "200px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.companyResponse?.companyName}</div>
      ),
    },
    {
      code: "email",
      name: "Email",
      width: "230px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.adminResponsePayload?.email}</div>
      ),
    },
    // {
    //   code: "modelName",
    //   name: "Maturity Model",
    //   width: "220px",
    //   sortable: true,
    //   selector: (row) => (
    //     <div className="table-cell-content">{row?.adminResponsePayload?.mobileNumber}</div>
    //   ),
    // },
    {
      code: "department",
      name: "Department",
      width: "210px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.department?.departmentName}</div>
      ),
    },
    {
      code: "hierarchy",
      name: "Hierarchy",
      width: "150px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.hierarchy?.hierarchyName}</div>
      ),
    },
    {
      code: "Duration",
      name: "Duration",
      width: "220px",
      sortable: false,
      selector: (row) =>
        moment(row?.assessorCampaignResponse?.durationFromDate).format("DD/MM/YYYY") +
        " - " +
        moment(row?.assessorCampaignResponse?.durationToDate).format("DD/MM/YYYY"),
    },
  ];

  return (
    <>
      {permissionAccess?.addAction === 0 &&
        permissionAccess?.updateAction === 0 &&
        permissionAccess?.viewAction === 0 ? (
        <AccessPermissionpage />
      ) : (
        <div className="modal_datatable">
          <TableHeading
            firstData="Assessor"
            icon={RIGHTARROW_ICON}
            secondData=""
          />
          <div className="container-fluid">
            <div className="caspera_admin_datatable mb-3">
              <SearchAndAddItem
                searchValue={searchText}
                onSearchChange={handleModelSearchChange}
                addButtonClick={addButtonClick}
                data="Employee"
                permissionAccessbtn={false}
                labelName="Select Company"
                lableclassName="addInput-label"
                name="companyId"
                options={companyList}
                className="form-control addInputText-lable"
                handleSelect={handleSelect}
                value={onSiteCompanyId ? onSiteCompanyId : selectedCompanyId}
                showDropdown={true}
                clearbtn={true}
                handleClear={handleClearFilter}
              />
              <AdminDataTable
                _tblColumns={tblColumns}
                _rowData={rowData}
                tableCustomStyles={tableCustomStyles}
                _totalRows={totalElement}
                pending={pending}
                setPending={setPending}
                pageSize={pageSize}
                setPageSize={setPageSize}
                setPage={setPage}
                setSortColumn={setSortColumn}
                setSortDirection={setSortDirection}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OnSiteAssessment;
